import React, { useState } from 'react';
import { AnimatedModal } from '../../components';
import SubscriptionIntro from '../SubscriptionIntro/SubscriptionIntro';
import bigLogo from '../../assets/logo-big.svg';
import styles from './VideoPlayer.module.css';
import { errorCode } from '../../constants';
import { useUserDetail } from '../../hooks';

export default function PlayerSubscription({
  isInteractive,
  onDismissPlayer,
  otherProps,
  error,
}) {
  const [customMessage, setCustomMessage] = useState(false);
  const { history } = otherProps;

  const { findUserSubsByName } = useUserDetail();
  const isSurgeUser = findUserSubsByName('surge');

  const goSubscribe = () => {
    history.push('/profile/subscription/buy-new');
  };
  const goRedeem = () => {
    history.push('/profile/redeem-voucher');
  };
  let content = <p>{`${error.message} (# ${error.code})`}</p>;
  //does not have video asset
  if (error.code === errorCode.MISSING_VIDEO) {
    content = <p>{`${error.message}`}</p>;
  }

  //not subscribed
  if (error.code === errorCode.NO_SUBSCRIPTION) {
    if (isInteractive) {
      history.push('/profile/subscription');
      return null;
    }

    content = (
      <div className={styles.subscriptionError}>
        <img src={bigLogo} alt='big-logo' />
        <p className={styles.subtitle}>
          You need to subscribe to watch this premium content
        </p>
        <SubscriptionIntro />

        {!isSurgeUser && (
          <>
            {/* <div className={styles.subscriptionList}></div> */}
            <button className={styles.subscribeButton} onClick={goSubscribe}>
              Pick subscription plan
            </button>

            <span className={styles.redeemtion} onClick={goRedeem}>
              Have a voucher? Redeem now.
            </span>
          </>
        )}
      </div>
    );
  }
  return (
    <>
      <div className={styles.errorWrapper}>
        <div className='vjs-dismiss-btn-wrapper' onClick={onDismissPlayer}>
          <i className='vjs-dismiss-player-icon' />
        </div>
        {content}
      </div>
      <AnimatedModal open={customMessage} isSmall={true}>
        <div className={styles.customMessageWrapper}>
          <h5>{customMessage}</h5>
          <button onClick={() => setCustomMessage(false)}>OK</button>
        </div>
      </AnimatedModal>
    </>
  );
}
